import publicKey from 'fotofun-config/publicVars/MERCADO_PAGO_PUBLIC_KEY';
import endpointBaseUrl from 'fotofun-config/publicVars/SERVICE_BASE_URL';

const config = {
  publicKey,
  endpointBaseUrl,
};

export default config;
